module.exports = __webpack_public_path__ + "img/logo_cdn_night.5582178b.png";